// @ts-nocheck
import React, { useState } from "react";
import { createPortal } from "react-dom";

const DeleteModalAdmin = ({
                            userRole,
                            targetRole,
                            userId,
                            handleDelete,
                            disabled,
                            disabledReason = "Sem permissão",
                          }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const closeModal = () => {
    setIsModalOpen(false);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleDeleteClick = async () => {
    if (disabled) return;

    setErrorMessage("");

    try {
      const result = await handleDelete(userId);

      if (!result?.success) {
        setErrorMessage(
            result?.message || "Não foi possível eliminar o utilizador."
        );
        return;
      }

      setSuccessMessage(
          `${
              targetRole?.toUpperCase() === "ADMIN"
                  ? "Administrador"
                  : "Gestor"
          } eliminado com sucesso!`
      );

      setTimeout(() => {
        closeModal();
      }, 1500);
    } catch (error) {
      const responseData = error?.response?.data;
      const message =
          (typeof responseData === "string"
              ? responseData
              : responseData?.message) ||
          "Ocorreu um erro inesperado. Por favor, tente novamente.";

      setErrorMessage(message);
      console.error("Error deleting user:", error);
    }
  };

  const handleMouseMove = (event) => {
    const tooltipWidth = 280;
    const margin = 12;

    setTooltipPosition({
      x: Math.max(
          margin,
          Math.min(event.clientX + 14, window.innerWidth - tooltipWidth - margin)
      ),
      y: Math.min(event.clientY + 14, window.innerHeight - 56),
    });
  };

  const roleLabel =
      targetRole?.toUpperCase() === "ADMIN" ? "administrador" : "gestor";

  return (
      <div
          className="relative inline-block"
          onMouseEnter={(event) => {
            if (disabled) {
              handleMouseMove(event);
              setShowTooltip(true);
            }
          }}
          onMouseMove={disabled ? handleMouseMove : undefined}
          onMouseLeave={() => setShowTooltip(false)}
      >
        <button
            onClick={() => !disabled && setIsModalOpen(true)}
            aria-label={disabled ? disabledReason : "Eliminar utilizador"}
            className={`w-6 h-5 transition-colors ${
                disabled
                    ? "cursor-not-allowed opacity-40"
                    : "hover:text-red-600"
            }`}
            disabled={disabled}
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-5"
          >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
            />
          </svg>
        </button>

        {showTooltip && disabled && typeof document !== "undefined" &&
            createPortal(
                <div
                    className="fixed w-max max-w-[280px] rounded-lg bg-gray-900 px-3 py-2 text-xs leading-5 text-white shadow-lg pointer-events-none whitespace-normal break-words"
                    style={{
                      left: tooltipPosition.x,
                      top: tooltipPosition.y,
                      zIndex: 9999,
                    }}
                    role="tooltip"
                >
                  {disabledReason}
                </div>,
                document.body
            )}

        {isModalOpen && (
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm px-4"
                onClick={closeModal}
            >
              <div
                  className="relative w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl"
                  onClick={(event) => event.stopPropagation()}
              >
                {/* Botão fechar */}
                <button
                    type="button"
                    onClick={closeModal}
                    aria-label="Fechar"
                    className="absolute right-5 top-5 z-10 flex h-9 w-9 items-center justify-center rounded-full text-gray-400 transition hover:bg-gray-100 hover:text-gray-700"
                >
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="h-5 w-5"
                  >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                <div className="p-7 sm:p-8">
                  {/* Cabeçalho */}
                  <div className="flex items-start gap-4">
                    <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-50">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.8}
                          stroke="currentColor"
                          className="h-6 w-6 text-red-600"
                      >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                        />
                      </svg>
                    </div>

                    <div className="pr-8">
                      <h2 className="text-xl font-semibold text-gray-900">
                        Eliminar {roleLabel}?
                      </h2>

                      <p className="mt-2 text-sm leading-6 text-gray-500">
                        Tem a certeza de que pretende eliminar este {roleLabel}?
                        Esta ação irá remover o acesso deste utilizador à
                        plataforma.
                      </p>
                    </div>
                  </div>

                  {/* Aviso */}
                  <div className="mt-6 rounded-xl border border-red-100 bg-red-50 px-4 py-3">
                    <div className="flex items-start gap-3">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.8}
                          stroke="currentColor"
                          className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-600"
                      >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                        />
                      </svg>

                      <p className="text-sm text-red-700">
                        Esta operação não pode ser anulada depois de concluída.
                      </p>
                    </div>
                  </div>

                  {/* Mensagens */}
                  {successMessage && (
                      <div className="mt-5 rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">
                        {successMessage}
                      </div>
                  )}

                  {errorMessage && (
                      <div className="mt-5 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                        {errorMessage}
                      </div>
                  )}
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 border-t border-gray-100 bg-gray-50 px-7 py-5 sm:px-8">
                  <button
                      type="button"
                      onClick={closeModal}
                      className="rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                  >
                    Cancelar
                  </button>

                  <button
                      type="button"
                      onClick={handleDeleteClick}
                      disabled={disabled}
                      className={`inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                          disabled
                              ? "cursor-not-allowed bg-gray-300"
                              : "bg-red-600 hover:bg-red-700 focus:ring-red-500"
                      }`}
                  >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.8}
                        stroke="currentColor"
                        className="h-4 w-4"
                    >
                      <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165"
                      />
                    </svg>

                    Eliminar {roleLabel}
                  </button>
                </div>
              </div>
            </div>
        )}
      </div>
  );
};

export default DeleteModalAdmin;